import appconfig from "../appconfig";
import { getDeliveryMethodByNumberValue } from "../domains2/libraries/DeliveryMethods";
import { Channel } from "../domains2/plugins/commonTypes/CommonTypes";
import { REMOVE_FROM_CART_BULK, SET_PRODUCT_IDS_FOR_RESELECTION, SET_UNAVAILABLE_PRODUCT_IDS } from "../store/mutation-types";

export const handleCartSelectionsWhenProductForPurchaseIsDisabled = async (self, err) => {
	if (err && err.response && err.response.data && err.response.data.errorName) {
		// this is for NEST errors coming from /orders POST/PATCH - the error/exception is different in nest because of
		// sprinting retail common library which additionally builds errors
		const errorCode = err.response.data.errorName;
		if (["ProductIsUndefinedError", "OrderAssortmentRuleBrokenError"].includes(errorCode)) {
			const isMobile = [Channel.mobileApp, Channel.mobileBrowser].includes(appconfig.channelAlias());
			if(isMobile) {
				self.orderAssortmentRuleBrokenErrorHappened = true;
				self.snackbar.visible = true;
			}
			let productId = "";
			const productIdMatch = (err.response.data.message || "").match(/productId.*"(.{36})"/);
			switch (errorCode) {
			case "OrderAssortmentRuleBrokenError":
			case "ProductIsUndefinedError":
				if (productIdMatch && productIdMatch["1"]) {
					productId = productIdMatch["1"];
				}
				break;
			}
			if (productId) {
				const ps = JSON.parse(err.response.config.data).productSelections;
				const disabledProduct = self.productCatalog.productMap[productId];
				self.undefinedProductName = disabledProduct.name;
				self.$store.commit(SET_UNAVAILABLE_PRODUCT_IDS, [productId]);
				if (self.featureToggles.useNewProductCatalog) {
					const deliveryChoice = self.$store.getters.tenantSpecificData;
					const deliveryMethodRef = getDeliveryMethodByNumberValue(deliveryChoice);
					await self.$store.dispatch("refreshProductCatalog", {
						deliveryMethod: deliveryMethodRef,
						invalidateCache: true
					});
				}
				if(!isMobile) {
					self.$store.dispatch("ADD_GLOBAL_ERROR", { friendlyMessage: self.productUndefinedErrorMessage });
				}
				const catalog = self.$store.getters.getNonCachedProductCatalog();
				const validProductIds = catalog.products.map(x => x.id);
				const isSimpleProductUnavailable = (id) => id === productId || !validProductIds.includes(id);
				const isMainProductInsideMenuUnavailable = (groups) => groups.find(g => (g.selectedProducts[0] === productId || !validProductIds.includes(g.selectedProducts[0])) && g.options.groupType === "main");
				const selectionsToRemove = ps.filter(x => isSimpleProductUnavailable(x.productId) || isMainProductInsideMenuUnavailable(x.groups));
				const menuSelectionsToReconfigure = ps.filter(x => 
					x.groups.length && x.groups.find(g => 
						g.selectedProducts.length && (
							g.appearance !== "amount" 
								? !validProductIds.includes(g.selectedProducts[0]) 
								: g.selectedProducts.some(selProd => !validProductIds.includes(selProd.productId))
						)
					)
				);
				const psToRemove = [...selectionsToRemove, ...menuSelectionsToReconfigure];
				self.$store.commit(REMOVE_FROM_CART_BULK, {productSelections: psToRemove});
				const productIds = [];
				menuSelectionsToReconfigure.forEach(x => {
					try {
						catalog.getProduct(x.productId);
						productIds.push(x.productId);
					} catch(e) {
						// do nothing
					}
				});
				
				self.$store.commit(SET_PRODUCT_IDS_FOR_RESELECTION, productIds);
			}
		}
	}
};

const getLastElement = (self) => {
	const {menuProductIdsForReselection} = self.$store.getters;
	const copy = [...menuProductIdsForReselection];
	if (copy.length) {
		const productId = copy.pop();
		return productId;
	}
	return null;
};
export const reconfigureMenuProductSelections = (self, productItems) => {
	const productId = getLastElement(self);
	if (productId) {
		const reselectMenu = productItems.find(product => product.product.id === productId);
		if (reselectMenu) {
			const ps = self.createCompositeSelectedProducts(reselectMenu);
			reselectMenu.productSelections.push(ps);
			self.openMenuDialog(reselectMenu);
		}
	}
};
export const reconfigureMenuProductSelectionsGt3 = (self) => {
	const productId = getLastElement(self);
	if (productId && productId === self.item.product.id) {
		self.addToCart(self.item);
	}
};
/**
 * @param {*} self 
 */
export const handleUnavailableSelectionsIfAny = (self) => {
	const {menuProductIdsForReselection} = self.$store.getters;
	const copy = [...menuProductIdsForReselection];
	if (copy.length) {
		copy.pop();
		self.$store.commit(SET_PRODUCT_IDS_FOR_RESELECTION, copy);
		if (copy.length === 0) {
			self.$store.commit(SET_UNAVAILABLE_PRODUCT_IDS, []);
		}
	}
};